import { Filter, TableRow } from './table-models';

/**
 * A single row of the logs of the system(also called chronology or history)
 * ---
 * Contains some information about a passed event, action executed by a user of the system or a system login.
 *
 * @param id - The id of the log
 * @param userId - The id of the user who caused the creation of the log
 * @param username - The username of the said user
 * @param createdOn - When was the log created
 * @param log - A displayable message
 * @param groupName - The group in which this log shows
 * @param operation - Enum in the backend, can export all values through {@link useGetLogOperations}
 * @see Option
 */
export interface Log extends TableRow {
    userId: number;
    userName: string;
    createdOn: Date;
    log: string;
    groupName: string;
    operation: string;
}

export interface LogFilter {
    searchBy?: string;
    userId?: string;
    createdAfter?: string;
    createdBefore?: string;
    createdOn?: string | null;
    operations?: string[];
}

export const toLogFilter = (filter: Filter): LogFilter => {
    let logFilter: LogFilter = {};

    if (filter) {
        logFilter.searchBy = filter.search;
        logFilter.userId = filter.id;
        logFilter.operations = filter.tags;
        logFilter.createdOn = filter['date'];
        logFilter.createdBefore = filter['before'];
        logFilter.createdAfter = filter['after'];
    }
    return logFilter;
};
